import React from 'react'
import {
  MUTUAL_FUND,
  ETF_FUND,
  ETF_INDEX_FUND,
  VARIABLE_FUND,
  FUTURE_SCHOLAR_529,
  CLOSED_END_FUND,
  MODEL_PORTFOLIOS,
} from '../../Helpers/FundTypes.js'
import FundDisclosureFootnotes from './FundDisclosureFootnotes.jsx'
import FundDisclosureMain from './FundDisclosureMain.jsx'

function FundDisclosures({ fund }) {
  return (
    <section
      className="section-content u-adel-reset"
      data-section-content="disclosures"
      id="new-disclosures"
    >
      <div
        data-fund-content-type={
          fund.fundCategory && fund.fundCategory.replace(/ /g, '')
        }
      >
        <div className="u-sizeConstrained">
          <div className="u-paddingVert12gu">
            <h2 className="u-marginBottom8gu">Disclosures</h2>

            {(fund.fundGroup === MUTUAL_FUND ||
              fund.fundGroup === ETF_FUND ||
              fund.fundGroup === ETF_INDEX_FUND ||
              fund.fundGroup === FUTURE_SCHOLAR_529 ||
              fund.fundGroup === MODEL_PORTFOLIOS ||
              fund.fundGroup === VARIABLE_FUND ||
              fund.fundGroup === CLOSED_END_FUND) &&
              fund.disclosures && <FundDisclosureFootnotes fund={fund} />}

            {fund.risk && fund.risk.disclosure && (
              <div
                id="riskDisclosures"
                className="Content u-marginBottom4gu riskDisclosures"
                dangerouslySetInnerHTML={{ __html: fund.risk.disclosure }}
              />
            )}

            {fund.disclosures && <FundDisclosureMain fund={fund} />}
          </div>
        </div>
      </div>
    </section>
  )
}
export default FundDisclosures
